import { datadogRum } from '@datadog/browser-rum';

import env from '@wetransfer/transfer/config/env';
import FFRecordRumTraces from '@wetransfer/transfer/constant/flags/record-rum-traces';
import { isBetaEnv, isLocalEnv } from '@wetransfer/transfer/modules/url';

import reportWebAssemblySupport from './rum/checkWASM';
import redactUniqueIDs from './rum/redactUniqueIDs';

const getWTDomainRegex = (domain: string) =>
  new RegExp(`https://(?!auth)(.+\\.)?${domain}\\.(com|net)($|/)`);

const getEnv = () => {
  if (isLocalEnv()) {
    return 'local';
  } else if (isBetaEnv()) {
    return 'staging';
  }

  return 'production';
};

const getSampleRate = () => {
  if (isBetaEnv() || isLocalEnv() || FFRecordRumTraces.isOn()) {
    return 100;
  }

  return 1;
};

const getPremiumSampleRate = () => {
  if (isBetaEnv() || isLocalEnv()) {
    return 100;
  }

  return 10;
};

const getTelemetrySampleRate = () => {
  return 100;
};

const init = (userId: string, planTier: string): void => {
  datadogRum.init({
    applicationId:
      env().NEXT_PUBLIC_DD_RUM_APPLICATION_ID ??
      '8ad3b331-fdf8-4935-a93a-63500a0ac535',
    clientToken:
      env().NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN ??
      'pubabbc81b16855ec184b0753bf36600da1',
    site: 'datadoghq.eu',
    service: env().NEXT_PUBLIC_DD_RUM_SERVICE ?? 'transfer-web',
    env: getEnv(),
    version: env().NEXT_PUBLIC_REVISION,
    sessionSampleRate: getSampleRate(),
    sessionReplaySampleRate: getPremiumSampleRate(),
    defaultPrivacyLevel: 'mask',
    telemetrySampleRate: getTelemetrySampleRate(),
    // If init is called twice, fail silently
    silentMultipleInit: true,
    trackResources: true,
    allowedTracingOrigins: [
      getWTDomainRegex('wetransfer'),
      getWTDomainRegex('wetransferbeta'),
      getWTDomainRegex('wetransferalpha'),
      /https:\/\/.*\.amazonaws\.com/,
      /lvh.me/,
    ],
    beforeSend(event) {
      if (event.type === 'resource') {
        event.resource.url = redactUniqueIDs(event.resource.url);
      }

      event.view.url = redactUniqueIDs(event.view.url);
    },
  });

  datadogRum.setUser({ id: userId, tier: planTier });
  datadogRum.setGlobalContextProperty('app-origin', 'decoupled');

  // Session's custom attributes
  reportWebAssemblySupport();
};

export { init };
